import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRelevantExams } from "../../actions/addRelevantExamsAction";
import { questionActions } from "../../reducers/questionCreateReducer";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {
  Theme,
  createStyles,
  WithStyles,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { MyPATExpansionPanel } from "../../../common";
import CancelIcon from "@material-ui/icons/Cancel";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { autofill } from "redux-form";
import AddFeedback from "../../../content-request/components/AddFeedback";
import _ from "lodash";
import {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../../common/MyPATBaseSection";
import SearchBarWithChips from "../../../course-Management/common/SearchBarWithChips";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import { CONTENT_SPECIAL_PURPOSES } from "../../../../constants/comman";
import contentService from "../../services/contentService";
import { SECTIONS } from "../../helper/contentValidation";
import AddFeedbackPopup from "./AddFeedbackPopup";

const styles = (theme: Theme) =>
  createStyles({
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    customInputBox: {
      marginBottom: "20px",
      "& input": {
        background: "rgb(255 255 255)",
        border: "1px solid rgb(223 223 223)",
        boxSizing: "border-box",
        borderRadius: 4,
        maxWidth: 400,
        width: "100%",
        height: 40,
        padding: "12px 16px",
        color: "rgb(102 102 102)",
        fontFamily: "Nunito, sans-serif",
        fontSize: 16,
        "&:focus": {
          outline: 0,
        },
      },
    },
    customChip: {
      background: "rgb(244 244 244)",
      borderRadius: 16,
      height: 30,
      margin: "3px 2px",
      display: "flex",
      alignItems: "center",
      minWidth: 110,
      justifyContent: "space-between",
      padding: "2px 3px 3px",
      "& .chipLabel": {
        fontSize: 12,
        padding: "0px 10px 0px",
        whiteSpace: "nowrap",
        color: "#666",
        fontWeight: 400,
        verticalAlign: "middle",
      },
      "& .chipIcon": {
        "& svg": {
          color: "#666",
          cursor: "pointer",
        },
      },
    },
    autoCompleteBox: {
      position: "relative",
      marginBottom: "15px",
      "& .options": {
        position: "absolute",
        background: "rgb(255 255 255)",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.12)",
        borderRadius: 8,
        overflowY: "auto",
        overflowX: "hidden",
        maxHeight: 130,
        padding: 0,
        width: "25rem",
        zIndex: 10,
        marginTop: 0,
        "&>li": {
          color: "#333",
          fontSize: 16,
          lineHeight: "20px",
          padding: "7px 12px",
          "&:hover": {
            background: "rgb(247 247 247)",
          },
        },
      },
      "& .dropDownList": {
        width: 400,
        border: "1px solid rgb(223 223 223)",
        background: "#fff",
        maxHeight: 300,
        overflowY: "auto",
        overflowX: "hidden",
        position: "absolute",
        zIndex: 1,
        borderRadius: 4,
      },
      "& .listItem": {
        padding: "0px 12px",
      },
      "& .search": {
        width: 400,
        border: "1px solid rgb(223 223 223)",
        // overflowX: 'auto',
        // overflowY: 'hidden',
        borderRadius: 4,
        minHeight: 40,
        background: "#fff",
      },
      "& .chipInput": {
        marginLeft: 6,
        // display: 'flex',
        alignItems: "center",
        width: "auto",
        // overflowX: 'auto',
        // overflowY: 'hidden',
        // minHeight: 40,
        // maxHeight: 100,
        // overflow: 'auto',
        "& .search-input-field": {
          position: "relative",
        },
        "& input": {
          display: "block",
          padding: "12px 4px",
          border: "none",
          // borderBottom: '1px solid #ededed',
          fontFamily: "Nunito, san-serif",
          height: "38px",
          marginBottom: "5px",
        },
        "& .chipContainer": {
          display: "flex",
          flexWrap: "wrap",
          maxHeight: 100,
          overflow: "auto",
        },
      },
      "& .option-active": {
        background: "#F7F7F7",
        fontSize: 16,
        color: "#333",
      },
      "& .search-btn": {
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        display: "block",
        padding: "6px 12px",
        color: "#666",
      },
    },
    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    chip: {},
    searchBarChips:{
      height: 'auto',
      '&>div:nth-of-type(1)':{
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 5px',
        '&>div:nth-of-type(1)':{
          '&>div:nth-of-type(1)':{
            '&>div:nth-of-type(1)':{
              '&>div:nth-of-type(1)':{
                overflow: 'initial',
              }
            }
          }
        }
      },
      '& svg':{
        cursor: 'pointer'
      },
      '& > div:nth-of-type(1) > div:nth-of-type(2) > div:nth-of-type(1)':{
        maxHeight: '150px',
      },
    },
    chipLabel:{
      fontSize:16,
      fontWeight:400,
      marginBottom: 10,
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    },
    headingRelative: {
      position: 'relative',
      display: 'inline-block',
    }
  });

interface RelevantExamsProps extends WithStyles<typeof styles> {
  getRelevantExams: any;
  allRelevantExams: any[];
  setAllRelevantExams: any;
  setRelevantExams: any;
  relevantExams: any[];
  isDisable: boolean;
  tag: string;
  openFeedback: boolean;
  addFeedback: Function;
  replyFeedback: Function;
  closeFeedback: Function;
  resolveFeedback: Function;
  clickedfeedbackData: any;
  addNewFeedback: Function;
  questionIndex?: number;
  selectedIndex: number;
  questionId?: string;
  authorType?: string;
  handleRelevantExamsChange?: (data: any[]) => void;
  onChangeRelevantExams?: (data: any[]) => void;
  questionSubType:string;
  isOptional: boolean;
  setUpdateRelevantExam: Function;
  setBenchmarkingUpdate: Function;
  questionSpecialPurposes: any;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
  defaultExpanded?: boolean;
}

interface Exam {
  id: string;
  name: string;
}
interface RelevantExamsStates {
  optionList: { label: string; value: string; id: string }[];
  showDropDownList: boolean;
  relevantExams: Exam[];
  searchText: string;
  courseList: Exam[];
  courseListInitailData: Exam[];
}

class RelevantExams extends Component<RelevantExamsProps, RelevantExamsStates> {
  state: RelevantExamsStates = {
    optionList: [],
    showDropDownList: false,
    relevantExams: [],
    searchText: "",
    courseList: [],
    courseListInitailData: [],
  };

  constructor(props: RelevantExamsProps) {
    super();
  }

  componentDidMount() {
    if (!this.props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
      this.props.getRelevantExams();
    } else {
      contentService.getSpecialPurposeCourses(CONTENT_SPECIAL_PURPOSES.RELEVANT_EXAMS).then((res) => {
        res.forEach((data: any)=>{
          data.id = data._id;
        });
        this.props.setAllRelevantExams(res);
      });
    }
  }

  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if (this.props.selectedIndex !== undefined) {
      return (
        (_.isEmpty(clickedfeedbackData) &&
          this.props.openFeedback &&
          this.props.tag === "relevantExams" &&
          this.props.selectedIndex === this.props.questionIndex) ||
        (!_.isEmpty(clickedfeedbackData) &&
          this.props.openFeedback &&
          clickedfeedbackData.tag === "relevantExams" &&
          questionId === clickedfeedbackData.contentId)
      );
    } else {
      return this.props.openFeedback && this.props.tag === "relevantExams";
    }
  }
  componentDidUpdate(prevProps: any) {
    if (prevProps.allRelevantExams !== this.props.allRelevantExams) {
      const courseListData = this.getCourseList(this.props.allRelevantExams);
      const optionList = courseListData.map(({ name, id }: any) => ({
        label: name,
        value: id,
        id,
      }));
      this.setState({
        courseList: courseListData,
        optionList,
        courseListInitailData: courseListData,
      });
    }
  }

  getCourseList = (allData: any) => {
    let courseListData;
    courseListData = allData && allData.map((course: any) => {
      if (this.props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
        return {
          id: course._id,
          name: course.name,
        }
      }
      return course.courseType
    });
    return courseListData;
  };

  handleRelevantExamSelection = (selections: any[] | null) => {
    // const doesItemAlreadyExist = this.props.relevantExams.filter(
    //   (exam: any) => exam.name === item.label
    // );
    // const { handleRelevantExamsChange } = this.props;
    // if (doesItemAlreadyExist.length === 0) {
    //   let { relevantExams } = this.props;
    //   let updatedRelevantExams = Object.assign([], relevantExams);
    //   updatedRelevantExams.push(item);
    //   this.props.setRelevantExams(updatedRelevantExams);
    //   handleRelevantExamsChange &&
    //     handleRelevantExamsChange(updatedRelevantExams);
    // } else {
    //   let { relevantExams } = this.props;
    //   const updatedRelevantExams = relevantExams.filter(
    //     (exam) => exam.name !== item.label
    //   );

    //   handleRelevantExamsChange &&
    //     handleRelevantExamsChange(updatedRelevantExams);
    // }

    const selectedExams = (selections || []).map((selection) => ({
      name: selection.label,
      id: selection.value,
    }));

    this.props.setRelevantExams(selectedExams);
    this.props.onChangeRelevantExams && this.props.onChangeRelevantExams(selectedExams);
    this.props.setUpdateRelevantExam(false);
    this.props.setBenchmarkingUpdate(false);
  };

  checkIfInRelevantExams = (item: any) => {
    const doesExamAlreadyExist = this.props.relevantExams.filter(
      (exam) => exam.name === item.name
    );
    if (doesExamAlreadyExist.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  // renderDropDownList = (searchText?: any) => {
  //   const { classes } = this.props;
  //   // const courseListData = this.getCourseList(this.props.allRelevantExams);

  //   let filteredCourses = this.state.courseList.filter((course: any) =>
  //     course.name.toLowerCase().startsWith(this.state.searchText.toLowerCase())
  //   );

  //   if (!filteredCourses.length) {
  //     return (
  //       <Grid className=" ">
  //         <p style={{ paddingLeft: "24px" }}>No relevant exams found.</p>
  //       </Grid>
  //     );
  //   }

  //   return filteredCourses.map((course: any, index: any) => (
  //     <Grid className=" " key={index}>
  //       <FormControlLabel
  //         // className={[classes.customRadio, classes.marginZero].join(" ")}
  //         style={{ marginLeft: 14 }}
  //         control={
  //           <Checkbox
  //             checked={this.checkIfInRelevantExams(course)}
  //             // classes={{
  //             //   root: classes.checkbox,
  //             //   checked: classes.checkedCheckbox,
  //             //   colorPrimary: classes.primaryColor,
  //             // }}
  //             onChange={(e) => this.handleCheckbox(e, course)}
  //             color="primary"
  //             disableRipple
  //           />
  //         }
  //         label={course.name}
  //         // classes={{ label: [classes.fontSize_SM, classes.grey].join(" ") }}
  //       />
  //     </Grid>
  //   ));
  // };

  toggleDropDownList = () => {
    this.setState({
      showDropDownList: !this.state.showDropDownList,
    });
  };

  showDropDownList = () => {
    if (!this.state.showDropDownList) {
      this.setState({
        showDropDownList: true,
        searchText: "",
      });
    }
  };

  hideDropDownList = () => {
    if (this.state.showDropDownList) {
      this.setState({
        showDropDownList: false,
      });
    }
  };

  // renderChips = () => {
  //   const { classes, relevantExams } = this.props;
  //   return this.props.relevantExams.map((exam: Exam, index) => (
  //     <span className={classes.customChip} key={index}>
  //       <span className="chipLabel"> {exam.name} </span>
  //       <span className="chipIcon" onClick={(e) => this.removeChip(e, exam)}>
  //         <CancelIcon />
  //       </span>
  //     </span>
  //   ));
  // };

  // removeChip = (e: any, item: any) => {
  //   const { classes } = this.props;
  //   let relevantExams = this.props.relevantExams;
  //   const updatedRelevantExams = relevantExams.filter(
  //     (exam) => exam.name !== item.name
  //   );
  //   this.setState({
  //     relevantExams: updatedRelevantExams,
  //   });
  //   this.handleCheckbox(e, item);
  // };

  handleSearchTextChange = (event: any) => {
    const { classes } = this.props;

    let updatedSearchText = event.target.value;
    this.setState({
      searchText: updatedSearchText,
    });
  };

  handleClickOutside = () => {
    this.hideDropDownList();
    this.setState({
      courseList: this.state.courseListInitailData,
    });
  };

  getTransformedValues = (relevantExams: Exam[]) => {
    return relevantExams.map((exam) => ({
      label: exam.name,
      id: exam.id,
      value: exam.id,
    }));
  };

  render() {
    const { classes, relevantExams, questionIndex, questionSubType, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback, defaultExpanded } = this.props;
    const { optionList } = this.state;

    return (
      <>
        <MyPATExpansionPanel
          defaultExpanded={defaultExpanded}
          // panelProps={{
          //   expanded,
          //   onChange: handleExpansion,
          // }}
          variant="white"
          hasExpandIcon
          customCollapseTitle={
            <>
              <Typography
                variant="h6"
                onClick={(event) =>
                  {
                    event.stopPropagation();
                    this.props.addFeedback("relevantExams", questionIndex)}
                }
                className={[classes.cardHeading, classes.headingRelative].join(' ')}
              >
                <span
                  id={this.checkForFeedback() ? "feedbackScroll" : ""}
                  className={`${classes.feedbackContainer} ${
                    this.checkForFeedback() ? classes.blueColor : ""
                  } ${
                    this.props.openFeedback ? classes.feedbackHighlight : ""
                  }`}
                >
                  Relevant Exam(s)
                  {
                    (!this.props.isOptional && ((questionSubType !== '3') && (<span style={{ color: "red" }}>*</span>)))
                  }
                  {this.checkForFeedback() && (
                    <Grid className="feedbackBlock">
                      <AddFeedback
                        author={this.props.authorType}
                        replyFeedback={this.props.replyFeedback}
                        closeFeedback={this.props.closeFeedback}
                        resolveFeedback={this.props.resolveFeedback}
                        clickedfeedbackData={this.props.clickedfeedbackData}
                        addNewFeedback={this.props.addNewFeedback}
                      />
                    </Grid>
                  )}
                  
                </span>
                <span className={classes.optionalText}> (Optional) </span>
                <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Relevant Exam(s)"
                imageURL="/assets/svg/infoIcon/relevantExams.svg"
                dialogPara="Tag the question with its relevant Target Exam(s)"
                details="Click to know more"
                toolTipDirection="top" />
                {
                  activeValidationFeedbackSection === SECTIONS.RELEVANT_EXAMS && (
                    <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                  )
                }
              </Typography>
              {
                <Typography
                  className={classes.errorText}
                  variant="caption"
                  color="error"
                >
                  {/* <Error /> */}
                  {/* {errorMessage} */}
                </Typography>
              }
            </>
            // )
          }
          isDisable={this.props.isDisable}
        >
          <SectionFocusedContext.Consumer>
            {({ setSectionFocus }: SectionFocusedContextValue) => (
              <Grid container>
                <Grid item xs={6}>
                  <Grid
                    className={[
                      classes.autoCompleteBox,
                      classes.customInputBox,
                    ].join(" ")}
                  >
                    <Typography className={classes.chipLabel}>Target Exam</Typography>
                    <div>
                      <SearchBarWithChips
                        suggestions={optionList}
                        onSelection={this.handleRelevantExamSelection}
                        values={this.getTransformedValues(relevantExams)}
                        textFieldProps={{
                          onFocus: () => setSectionFocus(true),
                          onBlur: () => {
                            setSectionFocus(false);
                          }
                        }}
                        placeholderText="Select Exam(s)"
                        notFound="No relevant exams found."
                        classes={{ root: classes.searchBarChips }}
                        source={'addConceptOrChapter'}
                        backspaceRemoves={true}
                      />
                      {/* <div className="chipInput">
                        <div className="search-input-field">
                          <div className="chipContainer">
                            {this.renderChips()}
                          </div>
                          <input
                            type="text"
                            className="search-box"
                            value={this.state.searchText}
                            onChange={this.handleSearchTextChange}
                            placeholder={
                              this.props.relevantExams.length === 0
                                ? "Select Exam(s)"
                                : ""
                            }
                            onFocus={() => setSectionFocus(true)}
                            onBlur={() => setSectionFocus(false)}
                            onClick={() => {
                              this.showDropDownList();
                            }}
                            // onBlur={() => this.toggleDropDownList()}
                          />

                          <span className="search-btn">
                            <KeyboardArrowDownIcon
                              onClick={() => this.toggleDropDownList()}
                            />
                          </span>
                        </div>
                      </div> */}
                    </div>
                    {/* {this.state.showDropDownList && (
                      <ClickAwayListener onClickAway={this.handleClickOutside}>
                        <Grid className="dropDownList">
                          {this.renderDropDownList()}
                        </Grid>
                      </ClickAwayListener>
                    )} */}
                  </Grid>
                </Grid>
              </Grid>
            )}
          </SectionFocusedContext.Consumer>
        </MyPATExpansionPanel>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    allRelevantExams: state.questionCreate.allRelevantExams,
    relevantExams: state.questionCreate.relevantExams,
    questionSpecialPurposes: state.questionCreate.specialPurposes,
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getRelevantExams,
      setAllRelevantExams: questionActions.setAllRelevantExams,
      setRelevantExams: questionActions.setRelevantExams,
      setUpdateRelevantExam: questionActions.setUpdateRelevantExam,
      setBenchmarkingUpdate: ((data: any) => dispatch({type: 'UPDATE_BENCHMARKING', data})),
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(RelevantExams));
